import { render, staticRenderFns } from "./backoffice-tempo-cirurgico-por-procedimento.vue?vue&type=template&id=94414ce0"
import script from "./backoffice-tempo-cirurgico-por-procedimento.vue?vue&type=script&lang=ts"
export * from "./backoffice-tempo-cirurgico-por-procedimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports